"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _SubscriptionEmail = _interopRequireDefault(require("./SubscriptionEmail"));

var _SubscriptionEmailTypes = require("./SubscriptionEmailTypes");

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchOptinEmailActionTypes.SUCCESS, function (state, action) {
  return state.set(_SubscriptionEmailTypes.OPTIN_EMAIL, new _SubscriptionEmail.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchOptinFollowupEmailActionTypes.SUCCESS, function (state, action) {
  return state.set(_SubscriptionEmailTypes.OPTIN_FOLLOWUP_EMAIL, new _SubscriptionEmail.default(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchResubscribeEmailActionTypes.SUCCESS, function (state, action) {
  return state.set(_SubscriptionEmailTypes.RESUBSCRIBE_EMAIL, new _SubscriptionEmail.default(action.payload.data));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;